<div class="custom-modal">
  <div class="header">
    <h1 mat-dialog-title>Liberação de Manifesto</h1>
    <mat-icon mat-dialog-close="cancel">close</mat-icon>
  </div>

  <div mat-dialog-content>
    <!-- <mat-progress-bar
      *ngIf="isLoading"
      color="primary"
      mode="indeterminate"
    ></mat-progress-bar> -->

    <!-- <div *ngIf="!isLoading"> -->
    <p>Insira seus dados para ter acesso ao sistema.</p>
    <form [formGroup]="formLogin">
    <mat-form-field appearance="outline">
      <mat-label>Digite seu Logon</mat-label>
      <input
        matInput
        placeholder="Digite seu nome de usuário"
        appAutoFocus
        name="loginAcesso"
        formControlName="loginAcesso"
        #inputEmail
        maxlength="100"
        required
      />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Digite sua senha</mat-label>
      <input matInput placeholder="Digite sua senha" name="passwordAcesso"
        formControlName="passwordAcesso" [type]="hide ? 'password' : 'text'" required #inputPassword />
      <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
        <mat-icon>
          {{ hide ? "visibility_off" : "visibility" }}
        </mat-icon>
      </button>
    </mat-form-field>
  </form>
  </div>
  <!-- </div> -->
  <div class="modal-actions" mat-dialog-actions align="end">
    <button mat-flat-button color="info" mat-dialog-close="cancel">
      Cancelar
    </button>
    <button mat-flat-button color="primary" (click)="liberarLogin()">Liberar transferência</button>
  </div>
</div>
